import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    paddingTop: theme.spacing(3),
  },
  dataGroup1: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
  },
  dataGroup2: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
  },
  dataVis: {
    paddingBottom: theme.spacing(2),
  },
}));

export default useStyles;
